import { createContext } from "react";

export const PainelVisivelContext = createContext(true);
